// extracted by mini-css-extract-plugin
export default {"banner":"index_banner_sBl1G"};